import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { EmStateAction, IAppStateEm } from '@theia-cc/em/state';
import { cleanEmptyProperties } from '@theia-cc/shared/helpers';
import { LanguageService, ShareLinkService } from '@theia-cc/shared/services';
import { ISplitQueryParamsResultEm } from './share-link.service';

@Injectable()
export class ShareOfferPreviewResolver implements Resolve<boolean> {
  constructor(
    private stepActions: EmStateAction,
    private store: NgRedux<IAppStateEm>,
    public shareLinkService: ShareLinkService,
    private languageService: LanguageService
  ) {}

  resolve(route: ActivatedRouteSnapshot): boolean {
    const { collectedData, Language } =
      this.shareLinkService.splitQueryParams<ISplitQueryParamsResultEm>(route.queryParams);

    if (Language) {
      this.languageService.setCurrentLanguage(Language);
    }

    if (
      this.store.getState().wizard.isSharedOfferPreview &&
      Object.keys(cleanEmptyProperties(collectedData)).length
    ) {
      this.stepActions.setConfigSettings(cleanEmptyProperties(collectedData));
    }

    return true;
  }
}
